var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { createElement, useContext, useEffect, useRef, useState, } from "react";
import SecondaryMainHeading from "../SecondMainHeading/SecondMainHeading";
import styles from "./CreateReport.module.scss";
import { getRoute } from "../../routes/getAllRoutes";
import { editing, StepManager, } from "../StepManager/StepManager";
import { InfoBarType, Label, Select, TextInput, TextInputWidth, } from "@eightfold.ai/octuple";
import Button, { ButtonVariant } from "../Button/Button";
import { Form } from "@eightfold.ai/octuple";
import { createRestrictedCohortReport, useGetCohortAvailableAssessmentsQuery, useGetCohortReportLeaderCount, useValidateUniqueCohortReportNameMutation, useGetClientPlatformQuery, useGetProjects, useGetSingleAvailableCohortReportsQuery, updateRestrictedCohortReport, mapCohortCategory, useGetDataFiltersQuery, useGetDataCustomFiltersQuery, useGetLeaderCustomScoresAssessmentAggBySkillGroupQuery, } from "../../store/api/core";
import { emptyFilters, FilterContext, getFilters, setFilters, updateFilters, } from "../../providers/FilterProvider";
import ChevronLeft from "../../icons/ChevronLeft";
import FormRequired from "../FormRequired";
import { FilterSelectPanel, useHasAllowableFilters, } from "../Filters/FilterSelectPanel";
import { CardOptions, TitledDescription } from "../CardOptions/CardOptions";
import InfoBar from "../InfoBar";
import { editingReportDataOptions, useReportData, } from "../../providers/ReportDataProvider";
import { useClient } from "../../hooks/client";
import { useNavigate, useParams } from "react-router-dom";
import SpinnerAndErrorer from "../SpinnerAndErrorer";
import ResetButton from "../ResetButton";
import Dialog from "../Dialog/Dialog";
import { createPortal } from "react-dom";
import { GlobalStateContext } from "../../providers/GlobalStateProvider";
import { allEntities, AvailableFilters, dataFilters, getEntity, getLabelForEntity, } from "../../common/filters";
import { getTabName, Tab } from "../../common/cohortHelpers";
import { ReloadableReportDataProvider } from "../../providers/ReloadableReportDataProvider";
import { isCohort, useDynamicOptions } from "../Filters/Filters";
import BackToButton from "../BackToButton";
import { TestTag, getAutomationTag } from "../../common/testAutomation";
import { ColumnDescribedTable, ValidSortDirections } from "../Table/Table";
import { cohortSet } from "../../common/cohortConfiguration";
import { getDynamicColumnHeader, getNameDefinitionValueTransformer, nameDefinition, useColumnedTableReportDataWithKnown, } from "../../common/cohortTableColumns";
import Tooltip, { TooltipPlacement } from "../Tooltip/Tooltip";
var StepOne = function (_a) {
    var _b;
    var done = _a.done, duplicateError = _a.duplicateError, setDuplicateError = _a.setDuplicateError;
    var _c = useReportData(), reportData = _c.reportData, setReportData = _c.setReportData;
    var form = Form.useForm()[0];
    var createReport = useValidateUniqueCohortReportNameMutation({
        invalidates: [
            { queryKey: ["{dashboard}/{ClientId}/cohort-report/validate-name"] },
        ],
    });
    var onFormFinish = function (formValues) {
        var _a;
        var initial = (_a = reportData.options) === null || _a === void 0 ? void 0 : _a.initialReportName;
        setDuplicateError(null);
        if (initial === formValues.reportName && initial == reportData.reportName) {
            done();
            return;
        }
        createReport.mutate({
            name: formValues.reportName,
        }, {
            onSuccess: function (data) {
                var _a;
                if ((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.isDuplicate) {
                    setDuplicateError("This report name is already taken, please use an alternative name.");
                }
                else {
                    setDuplicateError(null);
                    setReportData(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), { options: ((_a = prev.options) === null || _a === void 0 ? void 0 : _a.initialReportName)
                                ? __assign(__assign({}, prev.options), { initialReportName: formValues.reportName }) : prev.options, reportName: formValues.reportName }));
                    });
                    done();
                }
            },
        });
    };
    var doneText = "Continue";
    return (_jsxs(Form, __assign({ form: form, layout: "vertical", onFinish: onFormFinish, onFieldsChange: function () {
            if (duplicateError) {
                setDuplicateError(null);
            }
        } }, { children: [_jsx("div", __assign({ className: styles.stepOneContent }, { children: _jsxs("div", __assign({ className: styles.reportTitleContainer }, { children: [_jsx("div", __assign({ className: styles.reportTitle }, { children: "Report Name *" })), _jsx("div", __assign({ className: styles.reportNameDescriptionContainer }, { children: _jsx("div", __assign({ className: styles.reportNameDescription }, { children: "Consider a name that reflects the projects or leader groups to make the report easier to identify." })) }))] })) })), _jsx(Form.Item, __assign({ name: "reportName", rules: [{ required: true, message: "Report name is required" }], initialValue: reportData.reportName, validateStatus: duplicateError ? "error" : undefined, help: duplicateError && (_jsx("span", __assign({ className: styles.duplicateError }, { children: duplicateError }))) }, { children: _jsx(TextInput, { inputWidth: TextInputWidth.fill, value: reportData.reportName }) })), _jsxs("div", __assign({ className: styles.continueButtonContainer }, { children: [((_b = reportData.options) === null || _b === void 0 ? void 0 : _b.initialReportName) && (_jsx("span", __assign({ className: styles.cancelButton }, { children: _jsx(ResetButton, { label: "Cancel", onClick: function () {
                                setReportData(function (previous) {
                                    var _a;
                                    return (__assign(__assign({}, previous), { reportName: ((_a = previous === null || previous === void 0 ? void 0 : previous.options) === null || _a === void 0 ? void 0 : _a.initialReportName) || "" }));
                                });
                                done();
                            } }) }))), _jsx(Button, __assign({ text: doneText, variant: ButtonVariant.Secondary, className: styles.continueButton }, getAutomationTag(TestTag.PrimaryActionButtonNext), { disabled: !!duplicateError || createReport.isPending }))] }))] })));
};
var StepTwo = function (_a) {
    var _b, _c, _d;
    var done = _a.done, back = _a.back;
    var _e = useReportData(), reportData = _e.reportData, setReportData = _e.setReportData;
    var _f = useState(false), showInfoBar = _f[0], setShowInfoBar = _f[1];
    var availableAssessments = useGetCohortAvailableAssessmentsQuery({});
    var assessments = ((_c = (_b = availableAssessments === null || availableAssessments === void 0 ? void 0 : availableAssessments.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.assessments) || [];
    var options = Array.isArray(assessments)
        ? assessments.map(function (assessment) {
            return (_jsx(TitledDescription, { title: assessment.value, description: assessment.description }));
        })
        : [];
    var selectedCard = (_d = assessments === null || assessments === void 0 ? void 0 : assessments.map(function (_a, index) {
        var name = _a.name;
        return ({ name: name, index: index });
    }).find(function (_a) {
        var name = _a.name;
        return name == (reportData === null || reportData === void 0 ? void 0 : reportData.category);
    })) === null || _d === void 0 ? void 0 : _d.index;
    var setSelectedCard = function (index) {
        setFilters(emptyFilters);
        if (index == null) {
            setReportData(function (previous) { return (__assign(__assign({}, previous), { category: undefined, assessment: undefined })); });
            return;
        }
        assessments === null || assessments === void 0 ? void 0 : assessments.forEach(function (_a, index2) {
            var name = _a.name;
            if (index == index2) {
                setReportData(function (previous) { return (__assign(__assign({}, previous), { category: name, assessment: mapCohortCategory(name) })); });
            }
        });
    };
    var handleContinue = function () {
        var _a;
        if (selectedCard === undefined) {
            setShowInfoBar(true);
        }
        else {
            var selectedAssessment_1 = assessments[selectedCard].name;
            var mappedCategory_1 = mapCohortCategory(selectedAssessment_1);
            setReportData(function (prev) { return (__assign(__assign({}, prev), { assessment: mappedCategory_1, category: selectedAssessment_1 })); });
            // Update global filters with assessmentCategory
            updateFilters((_a = {},
                _a[getEntity(AvailableFilters.AssessmentCategory)] = [mappedCategory_1],
                _a));
            // Call done in next tick to allow state update to complete
            queueMicrotask(function () { return done(); });
        }
    };
    return (_jsxs("div", { children: [_jsx("div", __assign({ className: styles.stepOneContent }, { children: _jsx("h4", __assign({ className: styles.categoryHeading }, { children: "Pick an assessment to use as the basis for your report and data aggregation." })) })), _jsx(CardOptions, { showInfoBar: showInfoBar, options: options, selection: [selectedCard, setSelectedCard] }), showInfoBar ? (_jsx("div", __assign({ className: styles.infoContainer }, { children: _jsx(InfoBar, { content: "You need to select an assessment", type: InfoBarType.disruptive }) }))) : (""), _jsxs("div", __assign({ className: styles.assessmentButtonContainer }, { children: [_jsxs("div", __assign({ className: styles.buttonsContainer }, { children: [_jsx(ChevronLeft, {}), _jsx(Button, __assign({ text: "Back", variant: ButtonVariant.Neutral, className: styles.backButton }, getAutomationTag(TestTag.BtnBack), { onClick: back }))] })), _jsx(Button, __assign({ text: "Continue", variant: ButtonVariant.Secondary, className: styles.continueButton }, getAutomationTag(TestTag.PrimaryActionButtonNext), { onClick: handleContinue }))] }))] }));
};
var StepsTitle = function (_a) {
    var name = _a.name;
    return (_jsx("div", __assign({ className: styles.stepTitleContainer }, { children: _jsx("div", __assign({ className: styles.stepContainer }, { children: _jsx("span", __assign({ className: styles.stepTitle }, { children: name })) })) })));
};
var useLeaderCount = function () {
    var _a, _b;
    var reportData = useReportData().reportData;
    var getFilters = useContext(FilterContext).getFilters;
    var filters = getFilters();
    var response = useGetCohortReportLeaderCount({
        category: (reportData === null || reportData === void 0 ? void 0 : reportData.category) || "",
        filters: filters,
    }, { shouldSkipCall: function () { return !(reportData === null || reportData === void 0 ? void 0 : reportData.category); } });
    var raw = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.leadersCount;
    var value = typeof raw === "number"
        ? raw
        : typeof raw === "string"
            ? parseInt(raw, 10)
            : undefined;
    return __assign(__assign({}, response), { value: value });
};
var LeaderCountContainer = function () {
    var _a, _b, _c, _d;
    var reportData = useReportData().reportData;
    var getFilters = useContext(FilterContext).getFilters;
    var clientId = useClient().clientId;
    var filters = getFilters();
    // Fetch client data to get minThreshold
    var clientData = useGetClientPlatformQuery({}, { shouldSkipCall: function () { return !clientId; } }).data;
    var minThreshold = (_b = (_a = clientData === null || clientData === void 0 ? void 0 : clientData.data) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.minThreshold;
    var selectedProjectIds = filters[getEntity(AvailableFilters.Project)] || [];
    // Fetch all projects to check for confidential projects
    var allProjectsData = useGetProjects({}, { shouldSkipCall: function () { return !clientId; } }).data;
    var isConfidential = selectedProjectIds.length === 0
        ? ((_c = allProjectsData === null || allProjectsData === void 0 ? void 0 : allProjectsData.data) === null || _c === void 0 ? void 0 : _c.some(function (project) { return project.isCohortAnonymized === true; })) || false
        : ((_d = allProjectsData === null || allProjectsData === void 0 ? void 0 : allProjectsData.data) === null || _d === void 0 ? void 0 : _d.some(function (project) {
            return selectedProjectIds.includes(project.id) &&
                project.isCohortAnonymized === true;
        })) || false;
    var _e = useLeaderCount(), isError = _e.isError, isFetching = _e.isFetching, leadersCount = _e.value;
    var displayCount = !(reportData === null || reportData === void 0 ? void 0 : reportData.category)
        ? "--"
        : isFetching
            ? "Loading..."
            : isError
                ? "Error"
                : leadersCount != null && !Number.isNaN(leadersCount)
                    ? leadersCount.toLocaleString()
                    : "--";
    var confidentialError = isConfidential && leadersCount !== undefined && leadersCount < minThreshold;
    var nonConfidentialError = !isConfidential && leadersCount !== undefined && leadersCount === 0;
    var errorMessageFlag = confidentialError || nonConfidentialError;
    var errorStyles = errorMessageFlag
        ? {
            "--card-bg-color": "#FFF2ED",
            "--title-color": "var(--orange-color-500)",
        }
        : {};
    return (_jsx("div", { children: _jsx("aside", __assign({ className: styles.leaderCountWrapper }, { children: _jsxs("div", __assign({ className: styles.leaderCountCard, style: errorStyles }, { children: [_jsx("div", __assign({ className: styles.leaderCountTitle }, { children: "Number of leaders included in selection" })), _jsx("div", __assign({ className: styles.leaderCountValue }, { children: displayCount })), _jsx("div", { children: errorMessageFlag && (_jsxs("div", __assign({ className: styles.leaderCountLimitationTextContainer }, { children: [_jsx("img", { src: getRoute("FilledInforErrorIcon"), alt: "Info" }), _jsx("div", __assign({ className: styles.errorMessageIconAndText }, { children: confidentialError
                                        ? "Minimum group size not met. To protect individual confidentiality, at least ".concat(minThreshold, " leaders are required.")
                                        : "You need to have at least 1 leader to create a report. Please update your filters." }))] }))) })] })) })) }));
};
var LeaderCount = function () {
    var leadersCount = useLeaderCount().value;
    return _jsx(_Fragment, { children: !isNaN(Number(leadersCount)) && "".concat(leadersCount, " leaders") });
};
var StepThree = function (_a) {
    var done = _a.done, back = _a.back;
    return (_jsxs("div", __assign({ className: styles.stepThreeContainer }, { children: [_jsx(FilterSelectPanel, { className: styles.stepThreeFilters, done: done, back: back }), _jsx(LeaderCountContainer, {})] })));
};
var useDynamicFilters = function () {
    var _a;
    var getFilters = useContext(FilterContext).getFilters;
    var response = useGetDataCustomFiltersQuery({ filters: getFilters() });
    var options = new Set((Object.values(((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) || {}) || [])
        .map(function (_a) {
        var filterKey = _a.filterKey;
        return filterKey;
    })
        .filter(function (key) { return key; }));
    return Object.entries(getFilters() || {}).filter(function (_a) {
        var key = _a[0];
        return options.has(key);
    });
};
var useNonDynamicFilters = function () {
    var getFilters = useContext(FilterContext).getFilters;
    return Object.entries(getFilters() || {}).filter(function (_a) {
        var key = _a[0];
        return key != getEntity(AvailableFilters.AssessmentCategory) &&
            allEntities.has(key);
    });
};
var useReportPayloadFromReportData = function (reportData) {
    var filters = (isCohort() ? useDynamicFilters : useNonDynamicFilters)();
    return {
        name: reportData.reportName,
        assessmentCategory: mapCohortCategory(reportData.category),
        reportFilters: filters
            .map(function (_a) {
            var key = _a[0], values = _a[1];
            return ({
                filterField: key,
                filterValues: values || [],
            });
        })
            .filter(function (_a) {
            var _b;
            var filterValues = _a.filterValues;
            return ((_b = (filterValues || [])) === null || _b === void 0 ? void 0 : _b.length) > 0;
        }),
        leaderTableOptions: columnSelectKeys.reduce(function (acc, _a) {
            var _b;
            var key = _a.key;
            return (__assign(__assign({}, acc), (reportData[key] ? (_b = {}, _b[key] = reportData[key], _b) : {})));
        }, {}),
        heatmapDimensions: {
            xAxis: reportData.xAxis,
            yAxis: reportData.yAxis,
        },
    };
};
var ReportCreationButton = function () {
    var navigate = useNavigate();
    var reportData = useReportData().reportData;
    var createReport = createRestrictedCohortReport({
        invalidates: [{ queryKey: ["{dashboard}/{ClientId}/cohort-report"] }],
    });
    var hasValidHeatmapDimensions = !!reportData.xAxis &&
        !!reportData.yAxis &&
        reportData.xAxis !== reportData.yAxis;
    var payload = useReportPayloadFromReportData(reportData);
    var handleCreateReport = function () {
        if (!hasValidHeatmapDimensions) {
            return;
        }
        createReport.mutate(payload, {
            onSuccess: function (result) {
                var reportId = result.data.reportId;
                navigate(getRoute("CohortInsightsRestricted").replace(":reportId", reportId));
            },
            onError: function () {
                console.error("error");
            },
        });
    };
    return (_jsx(Button, __assign({ text: "Create Report", variant: ButtonVariant.Secondary, className: styles.continueButton }, getAutomationTag(TestTag.PrimaryActionButtonSubmit), { onClick: handleCreateReport, disabled: !hasValidHeatmapDimensions || createReport.isPending })));
};
var ToReportDoneButton = function (_a) {
    var done = _a.done;
    return (_jsx(Button, __assign({ text: "Continue", variant: ButtonVariant.Secondary, className: styles.continueButton }, getAutomationTag(TestTag.PrimaryActionButtonNext), { onClick: done })));
};
var useStepFourCustomOptions = function () {
    var response = useDynamicOptions();
    var options = __spreadArray([
        {
            value: getEntity(AvailableFilters.Project),
            text: dataFilters[AvailableFilters.Project].label,
        },
        {
            value: getEntity(AvailableFilters.AssessmentJourney),
            text: dataFilters[AvailableFilters.AssessmentJourney].label,
        }
    ], Object.values((response === null || response === void 0 ? void 0 : response.orderedFilters) || [])
        .filter(function (_a) {
        var heatmappable = _a.heatmappable, entity = _a.entity;
        return heatmappable &&
            entity !== getEntity(AvailableFilters.Project) &&
            entity !== getEntity(AvailableFilters.AssessmentJourney);
    })
        .map(function (_a) {
        var entity = _a.entity, label = _a.label;
        return ({
            value: entity,
            text: label,
        });
    }), true);
    return options;
};
var useStepFourNonCustomOptions = function () {
    var _a;
    var clientId = useClient().clientId;
    var response = useGetDataFiltersQuery({
        clientId: clientId,
        filters: getFilters(),
    });
    var allFiltersData = ((_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) || {};
    var heatmapFiltersOptions = [
        AvailableFilters.Project,
        AvailableFilters.BusinessFunctions,
        AvailableFilters.BusinessSubFunctions,
        AvailableFilters.JobLevels,
        AvailableFilters.Locations,
        AvailableFilters.LocationCountry,
        AvailableFilters.BusinessUnits,
        AvailableFilters.Division,
    ];
    var heatmapDropdownOptions = [];
    heatmapFiltersOptions.forEach(function (filter) {
        var _a = dataFilters[filter], entity = _a.entity, label = _a.label;
        Object.keys(allFiltersData)
            .filter(function (key) {
            var value = allFiltersData[key];
            return Array.isArray(value) && entity == key && value.length > 0;
        })
            .forEach(function (key) {
            heatmapDropdownOptions.push({
                text: label,
                value: key,
            });
        });
    });
    return heatmapDropdownOptions;
};
var useCustomFiltersPossibly = function () {
    return (isCohort() ? useStepFourCustomOptions() : useStepFourNonCustomOptions()) ||
        [];
};
var StepFour = function (_a) {
    var _b, _c;
    var back = _a.back, doneButton = _a.doneButton;
    var _d = useReportData(), reportData = _d.reportData, setReportData = _d.setReportData;
    var rowDimension = reportData.xAxis;
    var columnDimension = reportData.yAxis;
    var useDimensionHandler = function (axis) {
        var timer = useRef();
        var pending = useRef(undefined);
        return function (value) {
            var selected = Array.isArray(value) && value.length > 0 ? value[0] : undefined;
            if (selected) {
                pending.current = selected;
            }
            else if (!timer.current) {
                pending.current = undefined;
            }
            if (timer.current) {
                clearTimeout(timer.current);
            }
            timer.current = setTimeout(function () {
                timer.current = undefined;
                var finalValue = pending.current;
                pending.current = undefined;
                if (finalValue == reportData[axis]) {
                    return;
                }
                setReportData(function (previous) {
                    var _a;
                    return (__assign(__assign({}, previous), (_a = {}, _a[axis] = finalValue, _a)));
                });
            }, 50);
        };
    };
    var handleRowDimensionChange = useDimensionHandler("xAxis");
    var handleColumnDimensionChange = useDimensionHandler("yAxis");
    var heatmapDropdownOptions = useCustomFiltersPossibly();
    var rowDimensionOptions = React.useMemo(function () {
        return heatmapDropdownOptions.filter(function (opt) { return opt.value === rowDimension || opt.value !== columnDimension; });
    }, [heatmapDropdownOptions, columnDimension, rowDimension]);
    var columnDimensionOptions = React.useMemo(function () {
        return heatmapDropdownOptions.filter(function (opt) { return opt.value === columnDimension || opt.value !== rowDimension; });
    }, [heatmapDropdownOptions, rowDimension, columnDimension]);
    return (_jsx(SpinnerAndErrorer, __assign({ conditions: [
            { spin: function () { return heatmapDropdownOptions.length === 0; }, error: function () { return false; } },
        ] }, { children: _jsxs("div", __assign({ className: styles.heatmapGridContainer }, { children: [_jsxs("div", __assign({ className: styles.heatmapFilterSectionContainer }, { children: [_jsx("div", __assign({ className: styles.stepOneContent }, { children: _jsx("h4", __assign({ className: styles.categoryHeading }, { children: "To finish, pick two dimensions for the heatmap. The heatmap will group scores using these two dimensions, such as Project and Function." })) })), _jsxs("div", __assign({ className: styles.heatmapGridLabelContainer }, { children: [_jsx(Label, { classNames: styles.heatmapGridLabel, text: "Heatmap Row Dimension*" }), _jsx(Select, { options: rowDimensionOptions, dropdownProps: {
                                        placement: "bottom-start",
                                        positionStrategy: "absolute",
                                    }, defaultValue: reportData.xAxis, inputClassNames: styles.heatmapSelect, textInputProps: {
                                        clearButtonClassNames: styles.clearButton,
                                        placeholder: "",
                                    }, onOptionsChange: handleRowDimensionChange })] })), _jsxs("div", { children: [_jsx(Label, { classNames: styles.heatmapGridLabel, text: "Heatmap Column Dimension*" }), _jsx(Select, { options: columnDimensionOptions, dropdownProps: {
                                        placement: "bottom-start",
                                        positionStrategy: "absolute",
                                    }, defaultValue: reportData.yAxis, inputClassNames: styles.heatmapSelect, textInputProps: {
                                        clearButtonClassNames: styles.clearButton,
                                        placeholder: "",
                                    }, onOptionsChange: handleColumnDimensionChange })] }), _jsxs("div", __assign({ className: styles.assessmentButtonContainer }, { children: [_jsxs("div", __assign({ className: styles.buttonsContainer }, { children: [_jsx(ChevronLeft, {}), _jsx(Button, __assign({ text: "Back", variant: ButtonVariant.Neutral, className: styles.backButton }, getAutomationTag(TestTag.BtnBack), { onClick: back }))] })), doneButton] }))] })), rowDimension || columnDimension ? (_jsx("div", __assign({ className: styles.heatmapImageWrapperWithLabel }, { children: _jsxs(_Fragment, { children: [rowDimension && (_jsx("div", __assign({ className: styles.yAxisLabel }, { children: ((_b = heatmapDropdownOptions.find(function (opt) { return opt.value === rowDimension; })) === null || _b === void 0 ? void 0 : _b.text) || rowDimension }))), _jsx("img", { src: getRoute("HeatmapGridWithLabel"), alt: "Heatmap Grid", className: styles.heatmapGridWithLabelImage }), columnDimension && (_jsx("div", __assign({ className: styles.xAxisLabel }, { children: ((_c = heatmapDropdownOptions.find(function (opt) { return opt.value === columnDimension; })) === null || _c === void 0 ? void 0 : _c.text) || columnDimension })))] }) }))) : (_jsx("div", __assign({ className: styles.heatmapGridBlurryImageContainer }, { children: _jsx("div", __assign({ className: styles.heatmapImageWrapper }, { children: _jsx("img", { src: getRoute("BlurryHeatmapGrid"), alt: "Heatmap Grid", className: styles.heatmapGridBlurryImage }) })) })))] })) })));
};
// This is a hack because there is no endpoint to get the skill groups for hogan
// without a report ID
var skillGroupMapping = (_a = {},
    _a[Tab.HoganHDS] = "Bold",
    _a[Tab.HoganHPI] = "Adjustment",
    _a[Tab.HoganMVPI] = "Aesthetic",
    _a);
var AttributeTable = function (_a) {
    var category = _a.category, column1 = _a.column1, column2 = _a.column2, belowName = _a.belowName;
    var available = __assign(__assign(__assign({}, (column1 ? { column1Attribute: column1 } : {})), (column2 ? { column2Attribute: column2 } : {})), (belowName ? { belowNameAttribute: belowName } : {}));
    var cohortGroup = cohortSet[category];
    var dataKey = Object.keys(cohortGroup)[0];
    var seenData = useColumnedTableReportDataWithKnown(__assign({ useTableData: useGetLeaderCustomScoresAssessmentAggBySkillGroupQuery, skillGroup: dataKey || skillGroupMapping[category] || "", assessmentCategory: category }, available));
    if (!seenData) {
        return _jsx(_Fragment, {});
    }
    var data = seenData === null || seenData === void 0 ? void 0 : seenData.slice(0, 4).map(function (item) {
        var _a;
        return (__assign(__assign({}, item), (_a = {}, _a[column1] = item.column1Attribute, _a[column2] = item.column2Attribute, _a[belowName] = item.belowNameAttribute, _a)));
    });
    var moreCount = (seenData === null || seenData === void 0 ? void 0 : seenData.length) - (data === null || data === void 0 ? void 0 : data.length);
    var columnDescriptions = __spreadArray(__spreadArray([
        __assign(__assign({}, nameDefinition), { valueTransformer: getNameDefinitionValueTransformer(function (row) {
                return belowName ? (row === null || row === void 0 ? void 0 : row[belowName]) || "" : "";
            }) })
    ], (column1 ? [getDynamicColumnHeader(column1)] : []), true), (column2 ? [getDynamicColumnHeader(column2)] : []), true).map(function (value) { return (__assign(__assign({}, value), { defaultSortDirection: undefined, defaultSortOrderKey: undefined, isUnsortable: true })); });
    return (_jsxs("div", __assign({ className: styles.columnImageWrapper }, { children: [_jsx(ColumnDescribedTable, { data: data, columnDescriptions: columnDescriptions, replaceEmpty: "--", title: "", headerSx: { borderRadius: "0px" }, defaultSortKeyOrder: [
                    { column: "name", direction: ValidSortDirections.DESC },
                ] }), _jsx("div", __assign({ className: styles.moreCountText }, { children: _jsxs("span", { children: ["+ ", moreCount, " leaders"] }) }))] })));
};
var AttributeTableShell = function () {
    var _a = useReportData().reportData, category = _a.category, column1Attribute = _a.column1Attribute, column2Attribute = _a.column2Attribute, belowNameAttribute = _a.belowNameAttribute;
    if (!category) {
        return null;
    }
    return (_jsx(AttributeTable, { category: category, column1: column1Attribute, column2: column2Attribute, belowName: belowNameAttribute }));
};
var AttributeDisplayStep = function (_a) {
    var _b, _c, _d;
    var back = _a.back, done = _a.done;
    var clientId = useClient().clientId;
    var getContextFilters = useContext(FilterContext).getFilters;
    var selectedProjectIds = ((_b = getContextFilters()) === null || _b === void 0 ? void 0 : _b[getEntity(AvailableFilters.Project)]) || [];
    var allProjectsData = useGetProjects({}, { shouldSkipCall: function () { return !clientId; } }).data;
    // isConfidentialView is true if any selected project (or any project when none are selected) is anonymized.
    var isConfidentialView = selectedProjectIds.length === 0
        ? ((_c = allProjectsData === null || allProjectsData === void 0 ? void 0 : allProjectsData.data) === null || _c === void 0 ? void 0 : _c.some(function (p) { return p.isCohortAnonymized === true; })) ||
            false
        : ((_d = allProjectsData === null || allProjectsData === void 0 ? void 0 : allProjectsData.data) === null || _d === void 0 ? void 0 : _d.some(function (p) {
            return selectedProjectIds.includes(p.id) && p.isCohortAnonymized === true;
        })) || false;
    return (_jsxs("div", __assign({ className: styles.heatmapGridContainer }, { children: [_jsxs("div", __assign({ className: styles.heatmapFilterSectionContainer }, { children: [_jsx(Tooltip, __assign({ content: isConfidentialView
                            ? "Due to access restrictions, table configuration is disabled for confidential reports"
                            : "", placement: TooltipPlacement.Right }, { children: _jsxs("div", __assign({ style: isConfidentialView ? { pointerEvents: "none", opacity: 0.5 } : {} }, { children: [_jsx("div", __assign({ className: styles.stepOneContent }, { children: _jsx("h4", __assign({ className: styles.categoryHeading }, { children: "Select attributes to display in leader tables. Select one attribute to display below leaders' names. Select up to two attributes to display as columns." })) })), _jsx(DataAttributeSelections, {})] })) })), _jsx(BackOrContinueButtons, { back: back, handleContinue: done, disabled: false })] })), !isConfidentialView && _jsx(AttributeTableShell, {})] })));
};
var createTitles = {
    heading: function () { return "Create New Report"; },
    steps: [
        "Name the report",
        "Select an assessment",
        "Define the leader population",
        "Select the leader attributes to display",
        "Select the heatmap dimensions",
    ],
};
var editTitles = {
    heading: function (initialName) { return "".concat(initialName || "Report", ": Settings"); },
    steps: [
        "Report name",
        "Assessment",
        "Leader population",
        "Leader attributes to display",
        "Heatmap dimensions",
    ],
};
var ReportName = function () { return useReportData().reportData.reportName || ""; };
var ReportCategory = function () {
    var reportData = useReportData();
    var category = reportData.reportData.category || "";
    return getTabName(category);
};
var ReportColumnsPreview = function () {
    var reportData = useReportData().reportData;
    var options = (useCustomFiltersPossibly() || []).reduce(function (acc, _a) {
        var _b;
        var value = _a.value, text = _a.text;
        return (__assign(__assign({}, acc), (_b = {}, _b[value] = text, _b)));
    }, {});
    return (_jsx("div", __assign({ className: styles.reportColumns }, { children: columnSelectKeys
            .filter(function (_a) {
            var key = _a.key;
            return !!(reportData === null || reportData === void 0 ? void 0 : reportData[key]);
        })
            .map(function (_a) {
            var key = _a.key, label = _a.label;
            return (_jsx("div", { children: "".concat(label, ": ").concat((options === null || options === void 0 ? void 0 : options[reportData === null || reportData === void 0 ? void 0 : reportData[key]]) || (reportData === null || reportData === void 0 ? void 0 : reportData[key])) }));
        }) })));
};
var ReportColumns = function () { return _jsx(ReportColumnsPreview, {}); };
var ReportAxis = function () {
    var reportData = useReportData().reportData;
    return ((reportData === null || reportData === void 0 ? void 0 : reportData.xAxis) &&
        (reportData === null || reportData === void 0 ? void 0 : reportData.yAxis) &&
        "Rows: ".concat(getLabelForEntity(reportData.xAxis), " / Columns: ").concat(getLabelForEntity(reportData.yAxis)));
};
var InitialName = function (_a) {
    var _b, _c;
    var formatter = _a.formatter;
    var name = ((_c = (_b = useReportData().reportData) === null || _b === void 0 ? void 0 : _b.options) === null || _c === void 0 ? void 0 : _c.initialReportName) || "";
    return formatter ? formatter(name) : null;
};
var BackOrContinueButtons = function (_a) {
    var back = _a.back, handleContinue = _a.handleContinue, disabled = _a.disabled;
    return (_jsxs("div", __assign({ className: styles.assessmentButtonContainer }, { children: [_jsxs("div", __assign({ className: styles.buttonsContainer }, { children: [_jsx(ChevronLeft, {}), _jsx(Button, __assign({ text: "Back", variant: ButtonVariant.Neutral, className: styles.backButton }, getAutomationTag(TestTag.BtnBack), { onClick: back }))] })), _jsx(Button, __assign({ text: "Continue", disabled: disabled, variant: ButtonVariant.Secondary, className: styles.continueButton }, getAutomationTag(TestTag.PrimaryActionButtonNext), { onClick: handleContinue }))] })));
};
var DataAttributeSelections = function () {
    return columnSelectKeys.map(function (_a) {
        var key = _a.key, label = _a.label;
        return (_jsx("div", __assign({ className: styles.heatmapGridLabelContainer }, { children: _jsx(DataAttributeSelection, { label: label, dataKey: key }, key) })));
    });
};
var DataAttributeSelection = function (_a) {
    var label = _a.label, dataKey = _a.dataKey;
    var _b = useReportData(), reportData = _b.reportData, setReportData = _b.setReportData;
    var options = useCustomFiltersPossibly().filter(function (_a) {
        var value = _a.value;
        return value == reportData[dataKey] ||
            !columnSelectKeys.some(function (_a) {
                var key = _a.key;
                return reportData[key] == value;
            });
    });
    var onChange = function (value) {
        if (!value[0] || value[0] == reportData[dataKey]) {
            return;
        }
        setReportData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[dataKey] = value[0], _a)));
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx(Label, { classNames: styles.heatmapGridLabel, text: label }), _jsx(Select, { options: options, dropdownProps: {
                    placement: "bottom-start",
                    positionStrategy: "absolute",
                }, defaultValue: reportData[dataKey], inputClassNames: styles.heatmapSelect, textInputProps: {
                    clearButtonClassNames: styles.clearButton,
                    placeholder: "",
                }, onClear: function () {
                    setReportData(function (prev) {
                        var _a;
                        return (__assign(__assign({}, prev), (_a = {}, _a[dataKey] = undefined, _a)));
                    });
                }, onOptionsChange: onChange, clearable: true })] }));
};
var CreateReportContent = function (_a) {
    var backButton = _a.backButton, doneButton = _a.doneButton, titles = _a.titles, backgroundImage = _a.backgroundImage, seenSteps = _a.seenSteps, mutations = _a.mutations;
    var _b = useState(null), duplicateError = _b[0], setDuplicateError = _b[1];
    var steps = [
        {
            closeContent: function () { return (_jsx("div", __assign({ className: styles.reportName }, { children: _jsx(ReportName, {}) }))); },
            content: function (_a) {
                var done = _a.done;
                return (_jsx(StepOne, { done: done, duplicateError: duplicateError, setDuplicateError: setDuplicateError }));
            },
        },
        {
            closeContent: function () { return (_jsx("div", __assign({ className: styles.reportName }, { children: _jsx(ReportCategory, {}) }))); },
            content: function (_a) {
                var done = _a.done, back = _a.back;
                return (_jsx(StepTwo, { done: done, back: back }));
            },
        },
        {
            closeContent: function () { return (_jsx("div", __assign({ className: styles.reportName }, { children: _jsx(LeaderCount, {}) }))); },
            content: function (_a) {
                var done = _a.done, back = _a.back;
                return (_jsx(StepThree, { done: done, back: back }));
            },
        },
        {
            closeContent: function () { return (_jsx("div", __assign({ className: styles.reportName }, { children: _jsx(ReportColumns, {}) }))); },
            content: function (_a) {
                var done = _a.done, back = _a.back;
                return (_jsx(AttributeDisplayStep, { done: done, back: back }));
            },
        },
        {
            closeContent: function () { return (_jsx("div", __assign({ className: styles.reportName }, { children: _jsx(ReportAxis, {}) }))); },
            content: function (_a) {
                var done = _a.done, back = _a.back;
                return (_jsx(StepFour, { doneButton: createElement(doneButton, { done: done }), back: back }));
            },
        },
    ].map(function (step, index) { return (__assign(__assign(__assign({}, step), { title: _jsx(StepsTitle, { name: titles.steps[index] }) }), ((mutations === null || mutations === void 0 ? void 0 : mutations[index]) || {}))); });
    return (_jsxs(_Fragment, { children: [_jsx(SecondaryMainHeading, { backToButton: backButton, "data-testid": "SecondaryHeading", secondaryHeadingTitle: _jsx(InitialName, { formatter: titles.heading }), backgroundImage: getRoute(backgroundImage) }), _jsxs("div", __assign({ className: styles.wrapper }, { children: [_jsx("div", __assign({ className: styles.required }, { children: _jsx(FormRequired, {}) })), _jsx(StepManager, { steps: steps, seenSteps: seenSteps })] }))] }));
};
var useReportMutator = function (_a) {
    var reportId = _a.reportId;
    var _b = useState(false), error = _b[0], setError = _b[1];
    var updater = updateRestrictedCohortReport({
        substitutions: { id: reportId || "" },
        invalidates: [
            { queryKey: ["{dashboard}/{ClientId}/cohort-report/".concat(reportId)] },
        ],
    });
    var reportData = useReportData().reportData;
    var navigate = useNavigate();
    var payload = useReportPayloadFromReportData(reportData);
    var onClick = function () {
        updater.mutate(payload, {
            onSuccess: function () {
                navigate(getRoute("CohortInsightsRestricted").replace(":reportId", reportId));
            },
            onError: function () {
                setError(true);
            },
        });
    };
    var errorDialog = error
        ? createPortal(_jsx(Dialog, { header: "Update Error", body: "There was an error updating the report. Please try again.", visible: error, onClose: function () { return setError(false); } }), document.body)
        : null;
    return { onClick: onClick, errorDialog: errorDialog };
};
var ReportMutator = function (_a) {
    var reportId = _a.reportId;
    var mutator = useReportMutator({ reportId: reportId || "" });
    var getFilters = useContext(FilterContext).getFilters;
    var allowed = (isCohort() ? function () { return true; } : useHasAllowableFilters)();
    var report = useGetSingleAvailableCohortReportsQuery({ reportId: reportId || "" }, { shouldSkipCall: function () { return !reportId; } });
    var navigate = useNavigate();
    var reportData = useReportData().reportData;
    var isModified = useIsReportModified(report, reportData, getFilters()).isModified;
    var enabled = allowed && isModified;
    return (_jsx("div", __assign({ className: styles.mutator }, { children: mutator.errorDialog || (_jsx(Button, __assign({ text: "Update", variant: ButtonVariant.Secondary, className: styles.continueButton }, getAutomationTag(TestTag.PrimaryActionButtonSubmit), { onClick: function () {
                navigate(getRoute("CohortInsightsRestricted").replace(":reportId", reportId));
            }, disabled: !enabled }))) })));
};
var useDynamicMatchingFilters = function (one, two) {
    var _a;
    var client = useClient();
    var data = ((_a = useGetDataCustomFiltersQuery({ filters: getFilters() }, {
        shouldSkipCall: function () { return !client.clientId; },
    }).data) === null || _a === void 0 ? void 0 : _a.data) || [];
    var entities = data.map(function (_a) {
        var filterKey = _a.filterKey;
        return filterKey;
    });
    return !Object.values(entities).some(function (entity) {
        var oneValues = ((one === null || one === void 0 ? void 0 : one[entity]) || []).slice().sort();
        var twoValues = ((two === null || two === void 0 ? void 0 : two[entity]) || []).slice().sort();
        return JSON.stringify(oneValues) != JSON.stringify(twoValues);
    });
};
var useNonDynamicMatchingFilters = function (one, two) {
    return !Object.values(dataFilters).some(function (_a) {
        var entity = _a.entity;
        if (entity == getEntity(AvailableFilters.AssessmentCategory)) {
            return false;
        }
        var oneValues = ((one === null || one === void 0 ? void 0 : one[entity]) || []).slice().sort();
        var twoValues = ((two === null || two === void 0 ? void 0 : two[entity]) || []).slice().sort();
        return JSON.stringify(oneValues) != JSON.stringify(twoValues);
    });
};
var columnSelectKeys = [
    {
        label: "Attribute Below Leader Name",
        key: "belowNameAttribute",
    },
    {
        label: "Attribute Column 1",
        key: "column1Attribute",
    },
    {
        label: "Attribute Column 2",
        key: "column2Attribute",
    },
];
var useIsReportModified = function (report, reportData, filters) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
    if (filters === void 0) { filters = getFilters(); }
    var matching = (isCohort() ? useDynamicMatchingFilters : useNonDynamicMatchingFilters)((_a = report === null || report === void 0 ? void 0 : report.data) === null || _a === void 0 ? void 0 : _a.filters, filters);
    if (Object.keys(reportData !== null && reportData !== void 0 ? reportData : {}).length === 0) {
        return { isModified: false };
    }
    return {
        isModified: ((_b = report === null || report === void 0 ? void 0 : report.data) === null || _b === void 0 ? void 0 : _b.reportName) !== reportData.reportName ||
            ((_c = report === null || report === void 0 ? void 0 : report.data) === null || _c === void 0 ? void 0 : _c.assessmentCategory) !== reportData.category ||
            !matching ||
            columnSelectKeys
                .map(function (_a) {
                var key = _a.key;
                return key;
            })
                .some(function (key) { var _a, _b; return ((_b = (_a = report === null || report === void 0 ? void 0 : report.data) === null || _a === void 0 ? void 0 : _a.leaderTableOptions) === null || _b === void 0 ? void 0 : _b[key]) !== reportData[key]; }) ||
            ((_e = (_d = report === null || report === void 0 ? void 0 : report.data) === null || _d === void 0 ? void 0 : _d.leaderTableOptions) === null || _e === void 0 ? void 0 : _e.column1Attribute) !==
                reportData.column1Attribute ||
            ((_g = (_f = report === null || report === void 0 ? void 0 : report.data) === null || _f === void 0 ? void 0 : _f.leaderTableOptions) === null || _g === void 0 ? void 0 : _g.column2Attribute) !==
                reportData.column2Attribute ||
            ((_j = (_h = report === null || report === void 0 ? void 0 : report.data) === null || _h === void 0 ? void 0 : _h.leaderTableOptions) === null || _j === void 0 ? void 0 : _j.belowNameAttribute) !==
                reportData.belowNameAttribute ||
            ((_l = (_k = report === null || report === void 0 ? void 0 : report.data) === null || _k === void 0 ? void 0 : _k.heatmapDimensions) === null || _l === void 0 ? void 0 : _l.xAxis) !== reportData.xAxis ||
            ((_o = (_m = report === null || report === void 0 ? void 0 : report.data) === null || _m === void 0 ? void 0 : _m.heatmapDimensions) === null || _o === void 0 ? void 0 : _o.yAxis) !== reportData.yAxis,
    };
};
var CheckingDialog = function (_a) {
    var reportId = _a.reportId;
    var resetHoldUrl = useContext(GlobalStateContext).resetHoldUrl;
    var setFilters = useContext(FilterContext).setFilters;
    var navigate = useNavigate();
    var mutator = useReportMutator({ reportId: reportId });
    return (_jsx(Dialog, { header: "Report configuration has been updated", body: "Are you sure you want to save changes?", visible: true, onClose: function () {
            setFilters(emptyFilters);
            resetHoldUrl(navigate);
        }, buttons: {
            cancelButtonProps: {
                text: "Exit without saving",
                onClick: function () {
                    setFilters(emptyFilters);
                    resetHoldUrl(navigate);
                },
            },
            okButtonProps: {
                text: "Save and exit",
                onClick: function () {
                    mutator.onClick();
                    resetHoldUrl(navigate);
                },
            },
        } }));
};
var ModifiedLeaveBlock = function (_a) {
    var _b;
    var reportId = _a.reportId;
    var _c = useContext(GlobalStateContext), setHoldUrl = _c.setHoldUrl, getHoldUrl = _c.getHoldUrl;
    var _d = useReportData(), reportData = _d.reportData, setReportData = _d.setReportData;
    var mutator = useReportMutator({ reportId: reportId });
    var getFilters = useContext(FilterContext).getFilters;
    var report = useGetSingleAvailableCohortReportsQuery({ reportId: reportId }, { shouldSkipCall: function () { return !reportId; } });
    var isModified = useIsReportModified(report, reportData, getFilters()).isModified;
    useEffect(function () {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!(report === null || report === void 0 ? void 0 : report.data)) {
            return;
        }
        var initialReportData = __assign(__assign(__assign({ reportName: (_a = report === null || report === void 0 ? void 0 : report.data) === null || _a === void 0 ? void 0 : _a.reportName, category: (_b = report === null || report === void 0 ? void 0 : report.data) === null || _b === void 0 ? void 0 : _b.assessmentCategory, xAxis: (_d = (_c = report === null || report === void 0 ? void 0 : report.data) === null || _c === void 0 ? void 0 : _c.heatmapDimensions) === null || _d === void 0 ? void 0 : _d.xAxis, yAxis: (_f = (_e = report === null || report === void 0 ? void 0 : report.data) === null || _e === void 0 ? void 0 : _e.heatmapDimensions) === null || _f === void 0 ? void 0 : _f.yAxis }, ((report === null || report === void 0 ? void 0 : report.data.leaderTableOptions) || {})), columnSelectKeys.reduce(function (acc, _a) {
            var _b;
            var _c, _d;
            var key = _a.key;
            return (__assign(__assign({}, acc), (_b = {}, _b[key] = (_d = (_c = report === null || report === void 0 ? void 0 : report.data) === null || _c === void 0 ? void 0 : _c.leaderTableOptions) === null || _d === void 0 ? void 0 : _d[key], _b)));
        }, {})), { options: __assign(__assign({}, editingReportDataOptions), { initialReportName: (_g = report === null || report === void 0 ? void 0 : report.data) === null || _g === void 0 ? void 0 : _g.reportName }) });
        if (Object.keys(reportData || {}).length > 0) {
            return;
        }
        setTimeout(function () {
            setReportData(initialReportData);
        }, 0);
    }, [!(report === null || report === void 0 ? void 0 : report.data)]);
    if (isModified && ((_b = getHoldUrl()) === null || _b === void 0 ? void 0 : _b.onUrl) != (location === null || location === void 0 ? void 0 : location.pathname)) {
        setHoldUrl({
            onUrl: (location === null || location === void 0 ? void 0 : location.pathname) || "",
            urls: [
                new RegExp(getRoute("EditReport")
                    .replace(":reportId", "[a-fA-f\\d]+")
                    .replace(/\//g, "\\/")),
            ],
            dialog: _jsx(CheckingDialog, { reportId: reportId }),
        });
    }
    else if (!isModified && Object.keys(reportData || {}).length > 0) {
        setHoldUrl(undefined);
    }
    return mutator.errorDialog && _jsx(_Fragment, {});
};
export var EditReport = function () {
    var _a, _b;
    var reportId = useParams().reportId;
    var report = useGetSingleAvailableCohortReportsQuery({ reportId: reportId }, { shouldSkipCall: function () { return !reportId; } });
    useEffect(function () {
        var _a;
        var _b, _c;
        setFilters(__assign((_a = {}, _a[getEntity(AvailableFilters.AssessmentCategory)] = (_b = report === null || report === void 0 ? void 0 : report.data) === null || _b === void 0 ? void 0 : _b.assessmentCategory, _a), (((_c = report === null || report === void 0 ? void 0 : report.data) === null || _c === void 0 ? void 0 : _c.filters) || emptyFilters)));
    }, [(_a = report === null || report === void 0 ? void 0 : report.data) === null || _a === void 0 ? void 0 : _a.filters]);
    var mutations = [
        {
            done: function (setOnStep) {
                setOnStep(2);
            },
        },
        { pencil: function () { return _jsx(_Fragment, {}); } },
        {
            back: function (setOnStep) {
                setOnStep(0);
            },
        },
    ];
    return (_jsxs(_Fragment, { children: [_jsx(ModifiedLeaveBlock, { reportId: reportId || "" }, reportId), _jsx(SpinnerAndErrorer, __assign({ conditions: [report, { isError: false, isFetching: !reportId }] }, { children: _jsxs(ReloadableReportDataProvider, __assign({ filterCheckOverride: true }, { children: [_jsx(CreateReportContent, { titles: editTitles, doneButton: ToReportDoneButton, seenSteps: editing, mutations: mutations, backButton: _jsx(BackToButton, { title: ((_b = report === null || report === void 0 ? void 0 : report.data) === null || _b === void 0 ? void 0 : _b.reportName) || "Back", backUrl: getRoute("CohortInsightsRestricted").replace(":reportId", encodeURIComponent((reportId || "").replace(/[^a-zA-Z0-9_-]/g, ""))), backIcon: _jsx(ChevronLeft, {}) }) }, reportId), _jsx(ReportMutator, { reportId: reportId })] })) }), reportId)] }));
};
var CreateReport = function () {
    var setReportData = useReportData().setReportData;
    useEffect(function () {
        setReportData({});
        setFilters(emptyFilters);
    }, []);
    return (_jsx(ReloadableReportDataProvider, { children: _jsx(CreateReportContent, { titles: createTitles, doneButton: ReportCreationButton, backgroundImage: "CohortAndSuccessProfileHeaderBackground", backButton: _jsx(BackToButton, { title: "Cohort Insights", backUrl: getRoute("CohortInsightsV2"), backIcon: _jsx(ChevronLeft, {}) }) }) }));
};
export default CreateReport;
